<template>
  <div class="ui segment" style="padding: 0px;">
      <div class="content-top">
            <h1 class="ui header" >{{ boosterType != 'Unsubscribe' ? boosterType : '&#8291;' }}</h1>
            <div class="sash"><span>{{ sash }}</span></div>
            <div class="question" v-if="questionText">
                <img src='/static/img/question_mark.png' />
                <div v-html="questionText"></div>
            </div>
      </div>
      <div v-if="sash != 'Booster'" class="middle-stripe">
          <span v-if="boosterType == 'Invitation Accepted'">Beginning your booster experience.</span>
          <span v-if="boosterType == 'Invitation Declined'">Booster experience declined.</span>
          <span v-if="boosterType == 'Unsubscribe'">Unsubscribe from this program</span>
      </div>
      <div class="content-bottom">
          <div class="left">
            <div class="right" v-if="leaderboards && boosterType != 'View a Link'">
                <Leaderboard ref="leaderboard" :leaderboardData="leaderboards"/>
            </div>
            <div v-bind:class="getInnerClass()">
                <Announcement v-if="boosterType == 'Announcement'" v-bind:body="body" />
                <Poll v-if="boosterType == 'Poll'" v-bind:chartData="boosterData" v-bind:selectedOption="selection" v-bind:api="api" v-bind:programId="programId" v-bind:learnerId="learnerId" v-bind:boosterId="boosterId"/>
                <YouTube v-if="boosterType == 'Watch a Video'" v-bind:body="body" v-bind:boosterData="boosterData" />
                <FillInTheBlank v-if="boosterType == 'Fill in the Blank'" v-bind:boosterData="boosterData" @showLeaderboard="showLeaderboard" v-bind:leaderboards="(leaderboards) ? true : false" v-bind:api="api" v-bind:learnerId="learnerId" v-bind:programId="programId" v-bind:boosterId="boosterId"/>
                <MultipleChoice v-if="boosterType == 'Multiple Choice'" v-bind:boosterData="boosterData" v-bind:selectedOption="selection" @showLeaderboard="showLeaderboard" v-bind:leaderboards="(leaderboards) ? true : false" v-bind:learnerId="learnerId" v-bind:programId="programId" v-bind:boosterId="boosterId" v-bind:api="api"/>
                <MultiSelect v-if="boosterType == 'Multi-Select'" v-bind:boosterData="boosterData" v-bind:selectedOption="selection" @showLeaderboard="showLeaderboard" v-bind:leaderboards="(leaderboards) ? true : false" v-bind:programId="programId" v-bind:learnerId="learnerId" v-bind:boosterId="boosterId" v-bind:api="api"/>
                <WebLink v-if="boosterType == 'View a Link'" v-bind:boosterData="boosterData" />
                <ThoughtQuestion v-bind:api="api" v-if="boosterType == 'What do You Think?' && pageType == 'landing'" v-bind:boosterData="boosterData" v-bind:learnerId="learnerId" v-bind:boosterId="boosterId" v-bind:programId="programId"/>
                <ThoughtQuestionResponses v-if="boosterType == 'What do You Think?' && pageType == 'tq'" v-bind:boosterData="boosterData" v-bind:leaderboards="(leaderboards) ? true : false"/>
                <Unsubscribe v-if="boosterType == 'Unsubscribe'" v-bind:boosterData="boosterData" v-bind:api="api" v-bind:programId="programId" v-bind:learnerId="learnerId" />
                <div v-if="boosterType == 'Invitation Accepted' || boosterType == 'Invitation Declined'"> {{ body }} </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import Announcement from './boosters/Announcement.vue'
import Poll from './boosters/Poll.vue'
import YouTube from './boosters/YouTube.vue'
import FillInTheBlank from './boosters/FillInTheBlank.vue'
import MultipleChoice from './boosters/MultipleChoice.vue'
import MultiSelect from './boosters/MultiSelect.vue'
import WebLink from './boosters/WebLink.vue'
import Leaderboard from './Leaderboard.vue'
import ThoughtQuestion from './boosters/ThoughtQuestion.vue'
import ThoughtQuestionResponses from './boosters/ThoughtQuestionResponses.vue'
import Unsubscribe from './Unsubscribe.vue'
export default {
  name: 'ContentBox',
  props: {
      'boosterType': String,
      'body': String,
      'sash': String,
      'questionText': String,
      'boosterData': Object,
      'selection': Number,
      'leaderboards': Array,
      'pageType': {
          type: String,
          default () {
              return 'landing'
          }
      },
      'api': Function,
      'learnerId': Number,
      'programId': Number,
      'boosterId': Number
  },
  methods: {
      showLeaderboard: function() {
          this.$refs.leaderboard.leaderboardClick()
      },
      getInnerClass: function() {
          if (this.leaderboards) {
              return 'leaderboard-inner'
          }
          return ''
      }
  },
  watch: {
      boosterType: {
          immediate: true,
          handler() {
            if (!this.api) {
                return;
            }
            if (this.boosterType == 'Announcement' || this.boosterType == 'Poll' || this.boosterType == 'Watch a Video' || this.boosterType == 'Fill in the Blank' || 
            this.boosterType == 'Multiple Choice' || this.boosterType == 'View a Link' || this.boosterType == 'Multi-Select' || (this.boosterType == 'What do You Think?' && this.pageType == 'landing')) {
                this.api.post('/api/event', {
                    code: 300,
                    lid: this.learnerId,
                    pid: this.programId,
                    bid: this.boosterId
                })
            }
          }
      }
  },
  components: {
      Announcement,
      Poll,
      YouTube,
      FillInTheBlank,
      MultipleChoice,
      MultiSelect,
      WebLink,
      Leaderboard,
      ThoughtQuestion,
      ThoughtQuestionResponses,
      Unsubscribe
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-top {
    background-color: #ececec;
    min-height: 130px;
    padding: 15px;
    text-align: left;
}
.content-bottom {
    background-color: #FFF;
    padding: 15px;
    text-align: left;
    display: flex;
}
.sash {
    background: url('/static/img/sash_bg.png');
    width: 176px;
    height: 55px;
    color: #FFF;
    float: right;
    position: relative;
    left: 26px;
    top: -50px;
    font-size: 18px;
    font-family:sans-serif;
    padding: 15px;
}
.sash span {
    vertical-align: middle;
    display: inline-block;
}

.middle-stripe {
    padding: 2px 15px;
    height: auto;
    background-color: #428bca;
    color: #FFF;
    text-align: left;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
}
.question {
    margin-top: 30px;
    margin-bottom: 15px;
}
.question img {
    float: left;
    display: block;
    margin-right: 15px;
}
.question div {
    clear: both;
    position: relative;
    top: -40px;
    left: 30px;
    max-width: 88%;
    font-weight: bold;
    vertical-align: top;
    font-size: 18px;
}
.right {
    width: auto;
    max-height: 100px;
    top: 0px;
    right: 0px;
    float: right;
    padding: 5px;
}
.left {
   width: 100%;
   position: relative;
}
.leaderboard-inner {
    width: 82%;
}


@media (max-width: 640px) {
    .sash {
        background-image: none;
        background-color: #1b364f;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
    }
    .ui.segment {
        margin: 0px;
    }
    .content-top {
        padding: 0px;
    }

    .content-top .ui.header {
        margin-top: 55px;
        margin-left: 15px;
        padding-top: 10px;
    }

    .question {
        margin-left: 15px;
    }
    .leaderboard-inner {
        width: 100% !important;
    }
}
</style>

<style>
@media (max-width: 640px) {
    .content-bottom .left {
        display: table !important;
    }
    .content-bottom .left .right {
        width: 100% !important;
        max-width: 9999px;
        display: table-footer-group !important;
    }
    #leaderboard {
        width: 100% !important;
        margin-top: 45px;
        
    }
    #leaderboardButton {
        width: 100% !important;
    }
    .content-top {
        min-height: auto !important;
        padding-bottom: 10px !important;
    }
    .leaderboard-inner {
        display: table-header-group !important;
    }
}

</style>
